import { createApp } from "vue";
import App from "./App.vue";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import { createRouter, createWebHistory } from "vue-router";

import PrimeVue from "primevue/config";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import Dropdown from "primevue/dropdown";
import RadioButton from "primevue/radiobutton";
import BlockUI from "primevue/blockui";
import Panel from "primevue/panel";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Dialog from "primevue/dialog";
import Tooltip from "primevue/tooltip";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";

import "primevue/resources/themes/saga-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import CleanFilters from "@/components/CleanFilters";
import LoadBackError from "@/components/LoadBackError";
import ErrorView500 from "@/components/ErrorView500";
import FilterCardProceso from "@/components/FilterCardProceso";
import LinkCampana from "@/components/LinkCampana";
import LinkOrdinario from "@/components/LinkOrdinario";

import "./assets/css/styles.css";

const router = createRouter({
   history: createWebHistory(),
   routes: [
      { path: "/", component: FilterCardProceso },
      { path: "/limpiar", component: CleanFilters },
      { path: "/loadBackError", name: "LoadBackError", component: LoadBackError },
      { path: "/e500", name: "Error500", component: ErrorView500 },
      { path: "/detalle/precam/:idContabilidad", component: LinkCampana },
      { path: "/detalle/ordinario/:anio/:idContabilidad", component: LinkOrdinario },
   ],
});

const app = createApp(App);

app.use(router);

app.use(ToastService);
app.use(PrimeVue);
app.component("DataTable", DataTable);
app.component("DataColumn", Column);
app.component("DataColumnGroup", ColumnGroup);
app.component("DataRow", Row);
app.component("DropDown", Dropdown);
app.component("RadioButton", RadioButton);
app.component("BlockUI", BlockUI);
app.component("PanelC", Panel);
app.component("PrimeButton", Button);
app.component("InputText", InputText);
app.component("PrimeDialog", Dialog);
app.component("PrimeToast", Toast);
app.directive("tooltip", Tooltip);

app.mount("#app");
